(() => {
  const initialize = (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const $ = (s) => root.querySelector(s);
    const labels = JSON.parse($('[data-labels]').textContent);
    const cards = [...root.querySelectorAll('[data-product]')];
    const products = new Map(cards.map(card => [card.dataset.handle, card]));
    const storageKey = 'wisco-compare-v1';
    let selected = [];
    let visibleCount = 8;
    const params = new URLSearchParams(location.search);
    try { selected = params.has('compare') ? params.get('compare').split(',') : JSON.parse(localStorage.getItem(storageKey) || '[]'); } catch { selected = []; }
    if (!Array.isArray(selected)) selected = [];
    const requested = [...new Set(selected.filter(x => typeof x === 'string'))].slice(0, 3);
    selected = requested.filter(handle => products.has(handle));
    if (requested.length !== selected.length) $('[data-compare-status]').textContent = labels.unavailable;
    root.querySelectorAll('[data-controls], [data-compare-control]').forEach(el => { el.hidden = false; });
    [...new Set(cards.map(card => card.dataset.type).filter(Boolean))].sort().forEach(type => $('[data-type]').add(new Option(type, type)));
    const filter = () => {
      const search = $('[data-search]').value.trim().toLocaleLowerCase();
      const type = $('[data-type]').value;
      const budget = Number($('[data-budget]').value) || Infinity;
      const available = $('[data-available]').checked;
      const matches = cards.filter(card => card.dataset.title.toLocaleLowerCase().includes(search) && (!type || card.dataset.type === type) && Number(card.dataset.price) <= budget && (!available || card.dataset.available === 'true'));
      cards.forEach(card => { card.hidden = true; });
      matches.slice(0, visibleCount).forEach(card => { card.hidden = false; });
      $('[data-results]').textContent = labels.results.replace('__COUNT__', matches.length);
      $('[data-no-results]').hidden = matches.length !== 0;
      $('[data-more]').hidden = matches.length <= visibleCount;
    };
    const persist = () => { try { localStorage.setItem(storageKey, JSON.stringify(selected)); } catch {} };
    const shareUrl = () => {
      const url = new URL(location.pathname, location.origin);
      if (params.has('view')) url.searchParams.set('view', params.get('view'));
      if (params.has('preview_theme_id')) url.searchParams.set('preview_theme_id', params.get('preview_theme_id'));
      url.searchParams.set('compare', selected.join(','));
      url.hash = 'wisco-compare';
      return url.href;
    };
    const renderComparison = () => {
      const container = $('[data-comparison]');
      container.replaceChildren();
      root.querySelectorAll('[data-compare-pick]').forEach(box => { box.checked = selected.includes(box.value); });
      selected.forEach(handle => {
        const source = products.get(handle);
        const item = document.createElement('article');
        item.className = 'wt-comparison-card';
        const image = source.querySelector('.wt-image').cloneNode(true);
        const heading = source.querySelector('h4').cloneNode(true);
        const price = source.querySelector('[data-price-label]').cloneNode(true);
        const stock = source.querySelector('[data-stock]').cloneNode(true);
        const options = source.querySelector('[data-options]').cloneNode(true);
        options.hidden = false;
        const link = source.querySelector('.wt-product-link').cloneNode(true);
        const remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'wt-secondary';
        remove.textContent = labels.remove.replace('__TITLE__', source.dataset.title);
        remove.addEventListener('click', () => {
          const index = selected.indexOf(handle);
          selected = selected.filter(value => value !== handle);
          persist(); renderComparison();
          const next = container.querySelectorAll('button')[Math.min(index, selected.length - 1)];
          if (next) next.focus(); else root.querySelector(`[data-compare-pick][value="${CSS.escape(handle)}"]`)?.focus();
        });
        item.append(image, heading, price, stock, options, link, remove);
        container.append(item);
      });
      $('[data-compare-empty]').hidden = selected.length > 0;
      $('[data-share-controls]').hidden = selected.length === 0;
      $('[data-share-url]').value = selected.length ? shareUrl() : '';
    };
    root.addEventListener('change', event => {
      if (!event.target.matches('[data-compare-pick]')) return;
      const box = event.target;
      $('[data-compare-status]').textContent = '';
      if (box.checked && selected.length >= 3) {
        box.checked = false;
        $('[data-compare-status]').textContent = labels.limit;
        return;
      }
      selected = box.checked ? [...selected, box.value] : selected.filter(handle => handle !== box.value);
      persist(); renderComparison();
    });
    ['[data-search]', '[data-type]', '[data-budget]', '[data-available]'].forEach(selector => $(selector).addEventListener('input', () => { visibleCount = 8; filter(); }));
    $('[data-reset]').addEventListener('click', () => {
      $('[data-search]').value = ''; $('[data-type]').value = ''; $('[data-budget]').value = ''; $('[data-available]').checked = false;
      visibleCount = 8; filter(); $('[data-search]').focus();
    });
    $('[data-more]').addEventListener('click', () => {
      const oldVisible = new Set(cards.filter(card => !card.hidden));
      visibleCount += 8; filter();
      cards.find(card => !card.hidden && !oldVisible.has(card))?.querySelector('a')?.focus();
    });
    $('[data-clear]').addEventListener('click', () => {
      selected = []; persist(); renderComparison();
      $('[data-search]').focus();
    });
    $('[data-share]').addEventListener('click', async () => {
      try { await navigator.clipboard.writeText(shareUrl()); $('[data-compare-status]').textContent = labels.copied; }
      catch { $('[data-share-url]').focus(); $('[data-share-url]').select(); $('[data-compare-status]').textContent = labels.copyFailed; }
    });
    $('[data-idea-form]').addEventListener('submit', event => {
      event.preventDefault();
      const values = new FormData(event.currentTarget);
      const idea = values.get('idea').trim();
      if (!idea) { event.currentTarget.elements.idea.focus(); return; }
      const lines = [labels.briefIntro, '', `${labels.garment} ${values.get('garment')}`, `${labels.idea} ${idea}`];
      if (values.get('color').trim()) lines.push(`${labels.color} ${values.get('color').trim()}`);
      if (values.get('why').trim()) lines.push(`${labels.why} ${values.get('why').trim()}`);
      $('[data-brief]').value = lines.join('\n');
      $('[data-brief-panel]').hidden = false;
      $('[data-brief]').focus();
    });
    $('[data-handoff]').addEventListener('click', event => {
      const value = $('[data-brief]').value.trim();
      if (!value) { event.preventDefault(); $('[data-brief]').focus(); return; }
      try { sessionStorage.setItem('wisco-design-brief-v1', value); }
      catch {
        if (root.dataset.copyFallback !== 'true') {
          event.preventDefault(); root.dataset.copyFallback = 'true';
          $('[data-idea-status]').textContent = labels.storageFailed;
          $('[data-brief]').focus(); $('[data-brief]').select();
        }
      }
    });
    filter(); renderComparison();
  };
  const boot = (scope = document) => scope.querySelectorAll('[data-wisco-tools]').forEach(initialize);
  boot();
  if (!window.wiscoToolsListener) {
    document.addEventListener('shopify:section:load', event => boot(event.target));
    window.wiscoToolsListener = true;
  }
})();
